import React from 'react';
import { Users, Heart, Clock } from 'lucide-react';
import StatCard from '../../HrDashboard/utils/LoginStats';

const LoginStats = () => {
  const stats = [
    {
      icon: Users,
      label: 'Active Users',
      value: '2,400+',
      color: '#0095fa',
    },
    {
      icon: Heart,
      label: 'Patients Served',
      value: '1,200+',
      color: '#0f6caa',
    },
    {
      icon: Clock,
      label: 'Hours of Care',
      value: '50K+',
      color: '#0095fa',
    },
  ];

  return (
    <div className="space-y-4">
      {stats.map((stat, index) => (
         <StatCard
          key={index}
          icon={stat.icon}
          label={stat.label}
          value={stat.value}
          color={stat.color}
          trend={stat.trend}
          trendPercent={stat.trendPercent}
          description={stat.description}
          subtext={stat.subtext}
          gradient={true}
          size="medium"
        />
      ))}
    </div>
  );
};

export default LoginStats;